import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AuthServices from "../services/AuthServices";
import toast from "react-hot-toast";

const logIn = localStorage.getItem("access_token")
  ? localStorage.getItem("access_token")
  : null;

export const adminSignin = createAsyncThunk(
  "/admin/signin",
  async (finaldata) => {
    const res = await AuthServices.adminSigninApi(finaldata);
    return res.data;
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    redirect: false,
    logout: false,
    logIn,
  },
  reducers: {
    clearAuthRedirectState: (state) => {
      state.redirect = false;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(adminSignin.pending, (state) => {
        state.loading = true;
      })
      .addCase(adminSignin.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = true;
        state.logIn = true;
        // toast.success('Logged in sucessfully');
        localStorage.setItem("access_token", action.payload.token);
      })
      .addCase(adminSignin.rejected, (state, action) => {
        state.loading = false;
        state.redirect = false;
        state.logIn = false;
        toast.error(action.error.message);
      });
  },
});

export const { clearAuthRedirectState } = authSlice.actions;
const { reducer } = authSlice;
export default reducer;
